import { render, staticRenderFns } from "./MirrorFilters.vue?vue&type=template&id=37bfd901&scoped=true&"
import script from "./MirrorFilters.vue?vue&type=script&lang=js&"
export * from "./MirrorFilters.vue?vue&type=script&lang=js&"
import style0 from "./MirrorFilters.vue?vue&type=style&index=0&id=37bfd901&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bfd901",
  null
  
)

export default component.exports